export default class Map {
	constructor() {
		let bullits = document.querySelectorAll('.residences__bullet');
		let billitsArr = [...bullits];

		billitsArr.forEach(bullit => {
			bullit.addEventListener('click', (event) => {
        let content = document.querySelector('.residences__item-content.is--open');
        content?.classList.remove('is--open');

        let tooltip = event.target.closest('.residences__item').querySelector('.residences__item-content');
				if (tooltip) {
          tooltip.classList.toggle('is--open');
          document.querySelector('.residences__item-content.is--open .residences__item-content-close').addEventListener('click', (event) => { 
            tooltip.classList.remove('is--open');
          });
				}
			});
		});
	}
}